import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClipboard,
  faCopy,
  faDownload,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faLink,
  faMinus,
  faPlus,
  faRedo,
  faTimes,
  faUserCircle,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClipboard,
  faCopy,
  faDownload,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
  faLink,
  faMinus,
  faPlus,
  faRedo,
  faTimes,
  faUserCircle
);
